import { Typography } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const EmailWrapper = styled.div(
  ({ theme: { images } }) => css`
    -ms-overflow-style: none;
    background: url(${images.experienceEmailImage}) no-repeat center center;
    background-size: 500px 512px;
    border-radius: 24px;
    display: flex;
    flex: unset;
    flex-direction: column;
    height: 512px;
    margin-top: 16px;
    overflow: hidden;
    padding-left: 50px;
    padding-top: 90px;
    position: relative;
  `
);

const SenderName = styled(Typography)``;

const SubjectLine = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 140px;
`;

const Overlay1 = styled.div`
  background-color: var(--color-bg-overlay);
  display: ${({ isActive }) => (isActive ? 'block' : 'none')};
  height: 80px;
  left: 0px;
  opacity: 0.5;
  position: absolute;
  top: 0px;
  width: 240px;
`;

const Overlay2 = styled.div`
  background-color: var(--color-bg-overlay);
  bottom: 0px;
  display: ${({ isActive }) => (isActive ? 'block' : 'none')};
  height: 385px;
  left: 0px;
  opacity: 0.5;
  position: absolute;
  width: 240px;
`;

export { EmailWrapper, Overlay1, Overlay2, SenderName, SubjectLine };
